import { render } from "./DemoSwitcher.vue?vue&type=template&id=466f8217&scoped=true"
import script from "./DemoSwitcher.vue?vue&type=script&lang=js"
export * from "./DemoSwitcher.vue?vue&type=script&lang=js"

import "./DemoSwitcher.vue?vue&type=style&index=0&id=466f8217&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466f8217"]])

export default __exports__